<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { onChange } from '#app/lib/svelte/svelte'
  import Modal from '#components/modal.svelte'
  import type { SerializedGroup } from '#groups/lib/groups'
  import InventoryBrowser from '#inventory/components/inventory_browser.svelte'
  import { getInventoryView } from '#inventory/components/lib/inventory_browser_helpers'
  import type { InventoryView } from '#inventory/components/lib/inventory_browser_helpers'
  import type { RelativeUrl } from '#server/types/common'
  import { i18n } from '#user/lib/i18n'
  import UserInfobox from '#users/components/user_infobox.svelte'
  import type { SerializedUser } from '#users/lib/users'

  let {
    user = $bindable(),
    group = $bindable(),
    isMainUser = false,
    showModal = $bindable(false),
  }: {
    user: SerializedUser
    group: SerializedGroup
    isMainUser?: boolean
    showModal?: boolean
  } = $props()

  let inventoryViewPromise: Promise<InventoryView> | undefined = $state()
  let name: string | undefined = $state()
  let linkUrl: RelativeUrl | undefined = $state()
  let picture: SerializedUser['picture'] | undefined = $state()

  function closeModal () {
    showModal = false
    user = null
    group = null
  }

  function updateModalData ({ user, group }: { user?: SerializedUser, group?: SerializedGroup }) {
    if (!(user || group)) return
    if (user) {
      inventoryViewPromise = getInventoryView('user', user)
      ;({ username: name, picture } = user)
      linkUrl = `/users/${name}`
    } else if (group) {
      inventoryViewPromise = getInventoryView('group', group)
      name = group.name
      linkUrl = `/groups/${group.slug}`
    }
  }
  $effect(() => {
    onChange(user, () => updateModalData({ user }))
  })
  $effect(() => {
    onChange(group, () => updateModalData({ group }))
  })
</script>

{#if user || group}
  <div class="modal-wrapper">
    <Modal size="large" onCloseModal={closeModal}>
      <div class="header">
        <h2>
          {i18n('Public books')}
        </h2>
      </div>
      {#key name}
        {#if user}
          <UserInfobox
            {linkUrl}
            label={i18n('From user')}
            {name}
            {picture}
          />
        {:else if group}
          <span class="label">{i18n('From group')}</span>
          <Link
            url={linkUrl}
            text={name}
            classNames="link"
          />
        {/if}
      {/key}
      {#if inventoryViewPromise}
        <InventoryBrowser
          {inventoryViewPromise}
          ownerId={user?._id}
          groupId={group?._id}
          {isMainUser}
          frozenDisplay="table"
        />
      {/if}
    </Modal>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .modal-wrapper{
    :global(.modal-inner){
      min-width: 80vw;
      margin: 0 0.5em;
    }
    .header{
      @include display-flex(column, center);
    }
    h2{
      font-weight: bold;
      margin-block-start: 1em;
      font-size: 1.4em;
    }
    .label{
      color: $label-grey;
      display: block;
    }
    :global(.link){
      display: block;
      padding: 0.5em;
      font-weight: bold;
      @include radius;
      @include bg-hover($light-grey);
    }
  }
</style>
